import { render } from "./CertificationView.vue?vue&type=template&id=6cb3a030"
import script from "./CertificationView.vue?vue&type=script&lang=js"
export * from "./CertificationView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__